import React, { useEffect, useState } from "react";
import "./Exhibition.css";
import {
  Button,
  Modal,
  Pagination,
  Table,
  message,
  Input,
  Form,
  Select,
  DatePicker,
  Upload,
} from "antd";
import { get, post } from "../../apiService";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import "react-quill/dist/quill.snow.css"; // import styles for react-quill
import { getProfile } from "../../services/localStorageServices";
import TitleComp from "./TitleComp";
import { FaEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { PlusOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const { confirm } = Modal;
const { Option } = Select;

const Exhibition = () => {
  const [allquote, setAllQuote] = useState([]);
  const { profile } = getProfile();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [selectedExhibition, setSelectedExhibition] = useState(null);
  const [updateForm] = Form.useForm();
  const [addForm] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) =>
        image ? (
          <img
            src={image}
            alt="Exhibition"
            style={{ width: "100px", height: "auto" }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Venu",
      dataIndex: "venau",
      key: "venau",
    },
    {
      title: "Booth Name",
      dataIndex: "booth_name",
      key: "booth_name",
    },
    {
      title: "Booth No",
      dataIndex: "booth_no",
      key: "booth_no",
    },
    {
      title: "Exhibition Date",
      dataIndex: "exibition_date",
      key: "exibition_date",
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            className="bg-warning text-white"
            onClick={() => showUpdateModal(record)}
          >
            <FaEdit />
          </Button>
          <Button
            className="bg-danger text-white"
            onClick={() => showDeleteConfirm(record.exibition_id)}
          >
            <FaTrashAlt />
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 500);

    return () => clearTimeout(dbounce);
  }, [searchInput]);

  const fetchData = async (current, pageSize, search) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/exibition.php?limit=${pageSize}&page=${current}&type=exhibition&action=${action}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setAllQuote(response.list);
      const data = response?.list?.map((value) => ({
        ...value,
        exibition_date:
          moment(value.exibition_date).format("DD MMM") +
          " - " +
          moment(value.exibition_end).format("DD MMM"),
      }));
      setAllQuote(data);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const showDeleteConfirm = (exibitionId) => {
    confirm({
      title: "Are you sure you want to delete this exhibition?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => handleDelete(exibitionId),
    });
  };

  const handleDelete = async (exhibitionId) => {
    try {
      const formData = new FormData();
      // exibition_id
      formData.append("exibition_id", exhibitionId);
      formData.append("action", "update");
      formData.append("is_active", "0");
      const response = await post("/exibition.php", formData);

      if (response) {
        message.success("Exhibition deleted successfully");
        fetchData(pagination.current, pagination.pageSize);
      } else {
        message.error("Failed to delete exhibition");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while deleting the exhibition");
    }
  };

  const showUpdateModal = (record) => {
    setSelectedExhibition(record);
    updateForm.setFieldsValue({
      title: record.title,
      status: record.status,
      exibition_date: [
        moment(record.exibition_date),
        moment(record.exibition_end),
      ], // Convert to moment object
      image: record.image,
      venau: record.venau,
      booth_no: record.booth_no,
      booth_name: record.booth_name,
    });
    setFileList([{ url: record.image }]);
    setIsUpdateModalVisible(true);
  };

  const handleUpdate = async (values) => {
    try {
      const action = "update";
      const formData = new FormData();
      formData.append("action", action);
      formData.append("user_id", profile.user_id);
      formData.append("exibition_id", selectedExhibition.exibition_id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("status", values.status);
      formData.append("type", "exhibition");
      formData.append("venau", values.venau);
      formData.append("booth_no", values.booth_no);
      formData.append("booth_name", values.booth_name);
      formData.append(
        "exibition_date",
        values.exibition_date[0].format("YYYY-MM-DD")
      );
      formData.append(
        "exibition_end",
        values.exibition_date[1].format("YYYY-MM-DD")
      );
      if (values.image && values.image.file) {
        formData.append("image", values.image.file);
      }

      const response = await post(`/exibition.php`, formData);
      if (response) {
        message.success("Exhibition updated successfully");
        fetchData(pagination.current, pagination.pageSize);
        setIsUpdateModalVisible(false);
      } else {
        message.error("Failed to update exhibition");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while updating the exhibition");
    }
  };

  const handleAdd = async (values) => {
    try {
      const action = "add";
      const formData = new FormData();
      formData.append("action", action);
      formData.append("user_id", profile.user_id);
      formData.append("exibition_id", selectedExhibition.exibition_id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("type", "exhibition");
      formData.append("venau", values.venau);
      formData.append("booth_no", values.booth_no);
      formData.append("booth_name", values.booth_name);
      formData.append(
        "exibition_date",
        values.exibition_date[0].format("YYYY-MM-DD")
      );
      formData.append(
        "exibition_end",
        values.exibition_date[1].format("YYYY-MM-DD")
      );
      if (values.image && values.image.file) {
        formData.append("image", values.image.file);
      }

      const response = await post(`/exibition.php`, formData);
      if (response) {
        message.success("Exhibition added successfully");
        fetchData(pagination.current, pagination.pageSize);
        addForm.resetFields(); // Reset form fields after successful add
        setIsAddModalVisible(false);
      } else {
        message.error("Failed to add exhibition");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while adding the exhibition");
    }
  };

  const handleCancel = () => {
    setIsUpdateModalVisible(false);
  };

  const handleAddCancel = () => {
    setIsAddModalVisible(false);
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    if (pageSize !== pagination.pageSize) {
      fetchData(1, pageSize);
    } else {
      fetchData(current, pageSize);
    }
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  return (
    <div className="p-3">
      <div>
        <TitleComp
          name="Exhibitions List"
          type="Exhibition"
          totalData={pagination.total}
          button={
            <Button
              className="orderFilter-serach-btn"
              onClick={() => setIsAddModalVisible(true)}
              style={{ marginBottom: "16px" }}
            >
              Add Exhibition
            </Button>
          }
          setSearchInput={setSearchInput}
        />

        {/* Table for larger screens */}
        <div className="quotation-table">
          <Table
            columns={columns}
            dataSource={allquote}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
          />
        </div>

        {/* Cards for smaller screens */}
        <div className="quotation-cards">
          {allquote?.map((quote) => (
            <div className="quotation-card" key={quote.exibition_id}>
              {quote.image && (
                <img
                  src={quote.image}
                  alt="Exhibition"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
              <p>
                <strong>Title:</strong> {quote.title}
              </p>
              <p>
                <strong>Venu:</strong> {quote.venau}
              </p>
              <p>
                <strong>Boot Name:</strong> {quote.booth_name}
              </p>
              <p>
                <strong>Boot No:</strong> {quote.booth_no}
              </p>
              <p>
                <strong>Exhibition Date:</strong>{" "}
                {moment(quote.exibition_date).format("DD MMM") +
                  " - " +
                  moment(quote.exibition_end).format("DD MMM")}
              </p>

              <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                <Button
                  className="bg-warning text-white"
                  onClick={() => showUpdateModal(quote)}
                >
                  <FaEdit />
                </Button>
                <Button
                  className="bg-danger text-white"
                  onClick={() => showDeleteConfirm(quote.exibition_id)}
                >
                  <FaTrashAlt />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <Pagination
          className="mt-4"
          current={pagination.current}
          onChange={(page) =>
            setPagination((prev) => ({ ...prev, current: page }))
          }
          total={pagination.total}
        />
      </div>

      {/* Add Modal */}
      <Modal
        title="Add Exhibition"
        visible={isAddModalVisible}
        onCancel={handleAddCancel}
        footer={null}
      >
        <Form form={addForm} layout="vertical" onFinish={handleAdd}>
          <div className="row">
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please enter the title" }]}
            >
              <Input placeholder="Title" />
            </Form.Item>
            <Form.Item
              label="Exhibition Date"
              name="exibition_date"
              rules={[
                {
                  required: true,
                  message: "Please select the exhibition date",
                },
              ]}
            >
              <RangePicker style={{ width: "100%" }} format="DD MMM YYYY" />
            </Form.Item>
            <div className="col-md-6">
              <Form.Item
                label="Venu"
                name="venau"
                rules={[{ required: true, message: "Please enter venue" }]}
              >
                <Input placeholder="Venu" />
              </Form.Item>
            </div>
            <div className="col-md-6">
              <Form.Item
                label="Booth Name"
                name="booth_name"
                rules={[{ required: true, message: "Please enter Booth Name" }]}
              >
                <Input placeholder="Booth Name" />
              </Form.Item>
            </div>
            <div className="col-md-6">
              <Form.Item
                label="Booth No"
                name="booth_no"
                rules={[{ required: true, message: "Please enter Booth No" }]}
              >
                <Input placeholder="Booth No" />
              </Form.Item>
            </div>

            <Form.Item label="Image" name="image">
              <Upload
                beforeUpload={() => false}
                listType="picture"
                accept=".JPG, .JPEG, .PNG, .WEBP"
              >
                <Button style={{ width: "100%" }} icon={<UploadOutlined />}>
                  Upload Image
                </Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Button className="orderFilter-serach-btn" htmlType="submit">
                Add
              </Button>
              <Button
                type="default"
                onClick={handleAddCancel}
                style={{ marginLeft: "8px" }}
              >
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>

      {/* Update Modal */}
      <Modal
        title="Update Exhibition"
        visible={isUpdateModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {selectedExhibition && (
          <Form form={updateForm} layout="vertical" onFinish={handleUpdate}>
            <div className="row">
              <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please enter the title" }]}
              >
                <Input placeholder="Title" />
              </Form.Item>
              <Form.Item
                label="Exhibition Date"
                name="exibition_date"
                rules={[
                  {
                    required: true,
                    message: "Please select the exhibition date",
                  },
                ]}
              >
                <RangePicker style={{ width: "100%" }} format="DD MMM YYYY" />
              </Form.Item>
              <div className="col-12">
                <Form.Item
                  label="Venu"
                  name="venau"
                  rules={[{ required: true, message: "Please enter venue" }]}
                >
                  <Input placeholder="Venu" />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Booth Name"
                  name="booth_name"
                  rules={[
                    { required: true, message: "Please enter Booth Name" },
                  ]}
                >
                  <Input placeholder="Booth Name" />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Booth No"
                  name="booth_no"
                  rules={[{ required: true, message: "Please enter Booth No" }]}
                >
                  <Input placeholder="Booth No" />
                </Form.Item>
              </div>

              <Form.Item label="Image" name="image">
                <Upload
                  action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                  listType="picture-card"
                  fileList={fileList}
                  onChange={handleChange}
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
              </Form.Item>
              <Form.Item>
                <Button className="orderFilter-serach-btn" htmlType="submit">
                  Update
                </Button>
                <Button
                  type="default"
                  onClick={handleCancel}
                  style={{ marginLeft: "8px" }}
                >
                  Cancel
                </Button>
              </Form.Item>
            </div>
          </Form>
        )}
      </Modal>
    </div>
  );
};

export default Exhibition;
